import { RouteRecordRaw } from 'vue-router';
import { performancesOverviewGuards } from './guards/performances-overview.guard';

const performanceRoutes: Array<RouteRecordRaw> = [
   {
      path: '',
      name: 'PerformancesOverview',
      meta: { skipTitleGuard: true },
      component: () => import('@/modules/performances/pages/PerformancesOverview.vue'),
      beforeEnter: performancesOverviewGuards(),
   },
];

export default performanceRoutes;
